import request from '@/utils/http.js'

/**
 * @description 获取登录验证码
 * @returns {Promise}
 * @param userId
 */
export function boundCategories (userId, gradeId) {
  return request.get({
    url: `/api/student/course/bound-categories-with-progress/${userId}`,
    params: gradeId ? { gradeId } : {}
  })
}

/**
 * 查询学生全部年级及当前/已绑定/未绑定状态。
 * @param {number|string} userId
 * @returns {Promise}
 */
export function getStudentGradeOptions (userId) {
  return request.get({
    url: `/api/student/course/grades/${userId}`
  })
}

/**
 * 幂等初始化并切换学生当前学习年级。
 * @param {number|string} userId
 * @param {number|string} gradeId
 * @returns {Promise}
 */
export function switchStudentGrade (userId, gradeId) {
  return request.post({
    url: `/api/student/course/grades/${userId}/${gradeId}/switch`,
    config: { suppressGlobalError: true }
  })
}

/**
 * 生成随机测试接口
 * @param params
 * @returns {Promise}
 */
export function generateRandom (params) {
  return request.post({
    url: '/api/ai-test/generate-adaptive-by-kp',
    params
  })
}

/**
 * 批量答题接口
 * @param params
 * @returns {Promise}
 */
export function batchSubmit (params) {
  return request.post({
    url: '/api/student-test/batch-submit',
    params
  })
}

/**
 * 知识点列表查询
 * @param params
 * @returns {Promise}
 */
export function queryWithProgress (params) {
  return request.post({
    url: '/api/math/knowledge/query-with-progress',
    params
  })
}
export function getpointList ({ categoryId, difficultyLevel }) {
  return request.get({
    url: `/api/math/knowledge/category/${categoryId}/difficulty/${difficultyLevel}`
  })
}
export function historicalList ({ studentId, knowledgePointId }) {
  return request.get({
    url: `/api/student-test-record/student/${studentId}/knowledge-point/${knowledgePointId}`
  })
}
export function getQuestionsTest ({ testRecordId }) {
  return request.get({
    url: `/api/student-test/detail/${testRecordId}`
  })
}

/**
 * 根据历史测试记录ID获取分析报告
 * @param {number|string} id 测试记录ID
 * @returns {Promise}
 */
export function getAnalysisReportByRecordId (id) {
  return request.get({
    url: `/api/test-analysis-report/record/${id}`
  })
}
